// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#customer-review-div #head-flex h4[data-v-314e2c67]{color:#1c1c1c;font-size:45px;font-weight:900;line-height:55px}.vue-star-rating[data-v-314e2c67]{justify-content:center!important;width:100%!important}#cr-card[data-v-314e2c67]{border:1px solid #eaeaea;transition:.3s}#cr-card[data-v-314e2c67]:hover{border:1px solid #06a5d0;box-shadow:none!important;transition:.3s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
